/* ==========================================================================
   Anxie-T Presell — page scripts
   --------------------------------------------------------------------------
   Loaded by: sections/anxie-t-presell.liquid (deferred)
   Behaviour:
     - Scroll-reveal fade-in for [.reveal] elements
     - Sticky CTA shows after hero leaves viewport, hides over final CTA
   ========================================================================== */

(function () {
  // ---- Scroll reveal ----
  // Wrapped in IIFE so Shopify section re-renders (theme editor,
  // page transitions) don't re-declare consts.
  var revealElements = document.querySelectorAll('#anxie-t-presell .reveal');
  if ('IntersectionObserver' in window && revealElements.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealElements.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealElements.forEach(function (el) { el.classList.add('visible'); });
  }

  // ---- Floating / sticky CTA ----
  // Show after hero leaves viewport, hide while final CTA is visible.
  var stickyCta = document.getElementById('stickyCta');
  var hero = document.querySelector('#anxie-t-presell .hero');
  var finalCta = document.querySelector('#anxie-t-presell .cta-section');
  if (stickyCta && hero && 'IntersectionObserver' in window) {
    var heroVisible = true;
    var finalCtaVisible = false;
    function update() {
      var show = !heroVisible && !finalCtaVisible;
      stickyCta.classList.toggle('visible', show);
      stickyCta.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      update();
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        finalCtaVisible = entries[0].isIntersecting;
        update();
      }, { rootMargin: '0px 0px -20% 0px' }).observe(finalCta);
    }
  }
})();
